import React from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import FieldLabel from '../components/FieldLabel';
import { blockInvalidNumberKeys, sanitizeNumberInput } from '../utils/formHelpers';
import { outlinedFieldProps, disabledOutlinedSx } from '../utils/fieldStyles';

const DiscountCalcField = ({ field, data, change, basePrice }) => {
    const base = parseFloat(basePrice || 0);
    const pct = parseFloat(data.discount_percentage || 0);
    const discountAmount = pct ? (base * pct / 100).toFixed(2) : '';

    const handlePercentageChange = (value) => {
        const newPct = parseFloat(value || 0);
        const newAmount = newPct ? (base - (base * newPct / 100)).toFixed(2) : '';
        change({
            discount_percentage: value,
            discount_amount: newAmount,
        });
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <TextField
                    {...outlinedFieldProps}
                    label={<FieldLabel label="Discount (%)" tooltip={field.tooltips?.percentage} />}
                    type="number"
                    required
                    value={data.discount_percentage || ''}
                    onKeyDown={blockInvalidNumberKeys}
                    onChange={(e) => handlePercentageChange(sanitizeNumberInput(e.target.value))}
                    inputProps={{ inputMode: 'decimal' }}
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    {...outlinedFieldProps}
                    label={<FieldLabel label="Discount Amount ( Autocalculated )" tooltip={field.tooltips?.amount} />}
                    value={discountAmount}
                    disabled
                    sx={disabledOutlinedSx}
                />
            </Grid>
        </Grid>
    );
};

export default DiscountCalcField;
